export const MAIN_STORE_KEY = 'mainStore';
export const DASHBOARD_STORE_KEY = 'dashboardStore';
export const YOUR_CAR_STORE_KEY = 'yourCarStore';
export const YOUR_ADDRESS_STORE_KEY = 'yourAddressStore';
export const YOUR_DRIVERS_STORE_KEY = 'yourDriversStore';
export const YOUR_REGISTRATION_STORE_KEY = 'yourRegistrationStore';
export const REVIEW_STORE_KEY = 'reviewStore';
export const PREMIUM_STORE_KEY = 'premiumStore';
export const PAYMENT_STORE_KEY = 'paymentStore';
export const YOUR_MILEAGE_STORE_KEY = 'yourMileageStore';
export const WHERE_I_PARK_MY_CAR_KEY = 'whereIParkMyCarStore';
export const YOUR_VEHICLE_USAGE_STORE_KEY = 'yourVehicleUsageStore';
export const YOUR_DETAILS_STORE_KEY = 'yourDetailsStore';
